export default [
  {
    path: "/administration/setting",
    name: "Setting",
    component: () => import("@/components/master/setting/Setting"),
    meta: {
      title: "Global Setting",
      requiresAuth: true,
      services: ["Setting"]
    }
  },
  {
    path: "/administration/setting/term-conditions-form",
    name: "Term - Conditions",
    component: () => import("@/components/master/setting/TermConditionsForm"),
    meta: {
      title: "Term & Conditions",
      requiresAuth: true,
      services: ["Setting"]
    }
  },
  {
    path: "/administration/peak-period",
    name: "PeakPeriod",
    component: () => import("@/components/master/peakPeriod/PeakPeriod"),
    meta: {
      title: "Peak Period",
      requiresAuth: true,
      services: ["PeakPeriod"]
    }
  },
  {
    path: "/administration/pickup-offset",
    name: "PickUpOffset",
    component: () => import("@/components/master/pickupOffset/pickupOffset"),
    meta: {
      title: "PickUp Offset",
      requiresAuth: true,
      services: ["Region"]
    }
  },
  {
    path: "/administration/rate-tagging",
    name: "Tagging",
    component: () => import("@/components/master/tag/Tag"),
    meta: {
      title: "Rate Tagging",
      requiresAuth: true,
      services: ["Region"]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/administrationModule.js